export default __webpack_public_path__ + "alberta-person-cirle.f34b27e62c2061d8a615.svg";